export const HOME = "/";
export const LOGIN = "/login";
export const SINGUP = "/criar-conta";
export const FORGOT_PASSWORD = "/recuperar-conta";
export const CHOOSE_PIZZA_FLAVOURS = "/escolher-sabores";
export const CHOOSE_PIZZA_QUANTITY = "/escolher-quantidade";
export const CHOOSE_PIZZA_FOLLOWS = "/escolher-acompanhamentos";
export const CHOOSE_PIZZA_FOLLOW_QUANTITY = "/quantidade-acompanhamento";
export const CHOOSE_PIZZA_DRINKS = "/escolher-bebidas";
export const CHOOSE_PIZZA_DRINK_QUANTITY = "/quantidade-bebida";
export const CHECKOUT = "/checkout";
export const CHECKOUT_CONFIRMATION = `${CHECKOUT}/confirmar-pedido`;
export const CHECKOUT_SUCCESS = `${CHECKOUT}/sucesso`;
